import { Api } from '../ajax/Api';

export default Api;